<template>
  <div>
    <b-modal
      id="modal_confirm"
      ref="modal_confirm"
      modal-class="modal_tips"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      dialog-class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-md"
      header-class="modal-header justify-content-start align-items-center border-bottom-0"
      body-class="text-center"
      footer-class="modal-footer justify-content-center border-top-0"
    >
      <template v-slot:modal-header>
        <h4 class="mb-0">
          <b>{{ titleLabel }}</b>
        </h4>
        <button type="button" class="close rounded-circle m-0" @click="hideModal">
          <i class="icon-clear" />
        </button>
      </template>
      <template v-slot:modal-footer>
        <div class="wallet_transfer_btn modal_btns d-flex justify-content-center w-100">
          <button type="button" class="btn btn_transfer text-white" @click="submit">
            {{ submitLabel }}
          </button>
          <button class="btn btn_cancel" type="button" @click="cancel">
            {{ cancelLabel }}
          </button>
        </div>
      </template>
      <h6 class="mb-0">
        {{ message }}
      </h6>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'Confirm',
  computed: {
    message() {
      if (!this.$store.getters.confirmDialog) {
        return null
      }

      return this.$te(this.$store.getters.confirmDialog.message) ? this.$t(this.$store.getters.confirmDialog.message) : this.$store.getters.confirmDialog.message
    },
    submitLabel() {
      return this.$store.getters.confirmDialog.submitLabel
    },
    cancelLabel() {
      return this.$store.getters.confirmDialog.cancelLabel
    },
    titleLabel() {
      return this.$te('Bao.notice') ? this.$t('Bao.notice') : 'Notice'
    }
  },
  watch: {
    message(newVal, oldVal) {
      if (!newVal) {
        this.hideModal()
      } else {
        this.showModal()
      }
    }
  },
  mounted() {
    this.showModal()
  },
  methods: {
    showModal() {
      if (this.message) {
        this.$bvModal.show('modal_confirm')
      }
    },
    hideModal() {
      this.$bvModal.hide('modal_confirm')
      this.$store.commit('SET_CONFIRM_DIALOG', null)
    },
    submit() {
      const func = this.$store.getters.confirmDialog.submitFunc
      this.hideModal()
      if (func !== undefined && typeof func === 'function') {
        func()
      }
    },
    cancel() {
      const func = this.$store.getters.confirmDialog.cancelFunc
      this.hideModal()
      if (func !== undefined && typeof func === 'function') {
        func()
      }
    }
  }
}
</script>
